import { api } from "./api";

const CHUNK = 5 * 1024 * 1024;

export async function uploadInChunks(file, onProgress) {
  const total = Math.max(1, Math.ceil(file.size / CHUNK));
  const uploadId = [...crypto.getRandomValues(new Uint8Array(16))].map(b => b.toString(16).padStart(2, "0")).join("");
  let res;
  for (let i = 0; i < total; i++) {
    const fd = new FormData();
    fd.append("upload_id", uploadId);
    fd.append("index", i);
    fd.append("total", total);
    fd.append("filename", file.name);
    fd.append("content_type", file.type || "");
    fd.append("file", file.slice(i * CHUNK, (i + 1) * CHUNK), file.name);
    res = await api.post("/upload/chunk", fd, { headers: { "Content-Type": "multipart/form-data" } });
    onProgress?.(Math.round(((i + 1) / total) * 100));
  }
  return { path: res.data.path, filename: file.name, content_type: file.type };
}
